/**
 * Favicon sync — uses getAppLogo() so favicon matches app UI logos.
 */

import { getAppLogo } from "./getAppLogo"

export function syncFaviconWithTheme(): void {
  const link = document.getElementById("app-favicon") as HTMLLinkElement | null
  if (link) {
    link.href = getAppLogo()
  }
}
